import React, { useEffect, useState } from "react";
import classNames from "classnames";
import DatePicker from "../date-picker/date-picker";
import TimePickerInput from "../time-picker-input/time-picker-input";
import { combineDateAndTimeInput } from "utils";
import styles from "./date-time-range-picker-v2.module.scss";

const DateTimeRangePickerV2 = ({ value, onChange, name, disabled, className }) => {
  const [startDate, setStartDate] = useState(value?.startDate || null);
  const [endDate, setEndDate] = useState(value?.endDate || null);

  useEffect(() => {
    if (!value?.startDate && !value?.endDate) {
      setStartDate(null);
      setEndDate(null);
    }
  }, [value?.startDate, value?.endDate]);

  const emit = (sd, ed) => {
    onChange?.(name, { value: { startDate: sd, endDate: ed } });
  };

  const handleStartDateChange = (_, { value: newDate }) => {
    const combined = startDate ? combineDateAndTimeInput(newDate, startDate) : newDate;
    setStartDate(combined);
    emit(combined, endDate);
  };

  const handleStartTimeChange = (_, { value: newTime }) => {
    const combined = startDate ? combineDateAndTimeInput(startDate, newTime) : newTime;
    setStartDate(combined);
    emit(combined, endDate);
  };

  const handleEndDateChange = (_, { value: newDate }) => {
    const combined = endDate ? combineDateAndTimeInput(newDate, endDate) : newDate;
    setEndDate(combined);
    emit(startDate, combined);
  };

  const handleEndTimeChange = (_, { value: newTime }) => {
    const combined = endDate ? combineDateAndTimeInput(endDate, newTime) : newTime;
    setEndDate(combined);
    emit(startDate, combined);
  };

  return (
    <div className={classNames(styles.container, className, { [styles.disabled]: disabled })}>
      {/* Start row */}
      <div className={styles.row}>
        <DatePicker
          value={startDate}
          onChange={handleStartDateChange}
          placeholder="Start date"
          disabled={disabled}
          disableEndDate={endDate}
          className={styles.datePicker}
          hideIcon
        />
        <div className={styles.divider} />
        <TimePickerInput
          value={startDate}
          onChange={handleStartTimeChange}
          placeholder="--:-- --"
          disabled={disabled}
          className={styles.timePicker}
          actions={{ cancel: true, ok: true }}
        />
      </div>

      <div className={styles.rowDivider} />

      {/* End row */}
      <div className={styles.row}>
        <DatePicker
          value={endDate}
          onChange={handleEndDateChange}
          placeholder="End date"
          disabled={disabled}
          disableStartDate={startDate}
          className={styles.datePicker}
          hideIcon
        />
        <div className={styles.divider} />
        <TimePickerInput
          value={endDate}
          onChange={handleEndTimeChange}
          placeholder="--:-- --"
          disabled={disabled}
          className={styles.timePicker}
          actions={{ cancel: true, ok: true }}
        />
      </div>
    </div>
  );
};

export default DateTimeRangePickerV2;
